import { CircleCheck } from "lucide-react";

const DeleteRoleSuccess = ({ closeDeleteRoleSuccess }) => {
  return (
    <div
      onClick={(e) => {
        closeDeleteRoleSuccess();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <CircleCheck size={40} color="#00A676" />
        <p className="text-[#5C5C5C] text-center text-[16px] font-semibold">
          Success! Role deleted
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal text-center">
          You have successfully deleted the role.
        </p>
        <div className="flex items-center mt-[20px] justify-center">
          <button
            onClick={closeDeleteRoleSuccess}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRoleSuccess;
